import Head from 'next/head';
import NProgress from 'nprogress';
import { toast } from 'react-toastify';
import { routeKeys, storeKeys } from 'ui/data/constants/keys';
import { labels } from 'ui/data/constants/labels';
import { alertMsgs } from 'ui/data/constants/messages';
import { AuthProvider } from '@cogitate/diep2-components-core';
import { setStoreState, getStoreState, createSessionID } from '@cogitate/ui-multi-utils';
import {
  checkIsActiveUser,
  getLoginUserName,
  getLoginUserRole,
  loadInitalData,
  loadSelectedLineLob,
  onSearchUserDDMV2,
  // loadStaticItemsFromContainer,
} from 'ui/utilities/helper';
import { IMAGES_PATH_HELPER } from 'ui/utilities/staticAssetsPaths';
import { useRouter } from 'next/router';
export default function Login() {
  const router = useRouter();
  const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);

  const onSuccess = async (userObj, resolvedurl, error) => {
    if (!error) {
      setStoreState(storeKeys.LoggedInUserReducer, userObj);
      const selectedLineLobResult = await loadSelectedLineLob();
      if (selectedLineLobResult.length > 1) {
        window.location.href = process.env.NEXT_PUBLIC_PROJECT_URL + '/' + routeKeys.LobSelection.toLowerCase();
      } else {
        const userName = getLoginUserName(userObj);
        const role = getLoginUserRole(userObj);
        // This response exp will only fetch the Status of the loggedIn user like Active or InActive
        const responseExp = '{"Agent":Agent.{"Status":Status}, "Underwriter":Underwriter.{"Status":Status}}';
        const userData = await onSearchUserDDMV2(userName, role, responseExp);
        setStoreState(storeKeys.ApplicationReducer, {
          selectedBusinessLine: selectedLineLobResult[0],
        });

        if (userData) {
          const isActive = await checkIsActiveUser(
            userName,
            {
              PolicyDetails: {
                // If userData not returned from DDM API that means that user gets InActive!
                Agent: userData[0] ?? { Status: 'InActive' },
                Underwriter: userData[0] ?? { Status: 'InActive' },
              },
            },
            role
          );
          if (!isActive) {
            // If user is InActive redirect to login page;
            toast.error(alertMsgs.Shared.LoginNotAllowed);
            setTimeout(() => {
              window.location.href = process.env.NEXT_PUBLIC_AUTH_SSO_URL + process.env.NEXT_PUBLIC_PROJECT_URL;
            }, 4000);
          } else {
            // await loadStaticItemsFromContainer();
            await loadInitalData();
            window.location.href = process.env.NEXT_PUBLIC_PROJECT_URL + routeKeys.DashboardAccountHub.toLowerCase();
          }
        } else {
          throw new Error('User Data Fetching failed');
        }
      }
    } else {
      toast.error(alertMsgs.Login.LoginFailed);
      router.push(routeKeys.Root);
      NProgress.done();
    }
  };

  return (
    <>
      <Head>
        <title>{labels.Shared.Login.PageTitle}</title>
        <meta name="description" content="Developed By Team Cogitate" />
        <link rel="icon" href={`${IMAGES_PATH_HELPER}/login-ca.png`} />
      </Head>
      <AuthProvider
        AuthUrl={process.env.NEXT_PUBLIC_AUTH_SSO_URL + encodeURIComponent(process.env.NEXT_PUBLIC_PROJECT_URL)}
        UserStore={loggedInUser}
        onSuccess={onSuccess}
        concurrencyProps={{ createSessionID }}
      >
        <div className="processContainer virtualBackground d-flex vh-100 justify-content-center align-items-center">
          <div className="processBox col-4 my-auto text-center pb-5 shadow rounded">
            <h4 className="proHeader py-2">Validating User</h4>
            <div className="proBody">
              <div class="lds-ripple my-3">
                <div></div>
                <div></div>
              </div>
              <h5 className="mb-3" style={{ color: 'black' }}>
                Almost there...
              </h5>
            </div>
          </div>
        </div>
      </AuthProvider>
    </>
  );
}

Login.layout = 'L1';
